import React from 'react'
import RightRibbon from 'common/modules/bidBanner/container/rightRibbon'
import { constants } from '@adc/ui-adc'
import { AuctionBlueprintScheduledOnlineReactiveArgs } from '@adc/blueprint'
import * as graph from '@adc/sdk'

interface ReserveMetRibbonProps {
  segment: AuctionBlueprintScheduledOnlineReactiveArgs['segment']
}

const ReserveMetRibbon = ({ segment }: ReserveMetRibbonProps) => {
  return segment.reserve_status === graph.enums.ReserveStatus.ReserveMet ? (
    <RightRibbon color={constants.ColorNames.Success} text='Reserve Met!' />
  ) : null
}

export default ReserveMetRibbon
